<template>
  <div class="VODbutton clickable" :class="active?'active':'inactive'" @click="$emit('toggle', !active);">
    <div class="VODimage" :style="{backgroundImage: 'url(' + imageUrl + ')'}" :class="active?'':'inactiveInverse'">

    </div>
  </div>
</template>

<script>
export default {
  name: "VODbutton",
  props:['imageUrl', 'active'],
  model: {
    prop: 'active',
    event: 'toggle'
  },
}
</script>

<style scoped>
  .VODbutton{
    padding: 1vw;
    margin: 1vw;
    height: 4vw;
    min-height: 4vw;
    width: 8vw;
    min-width: 8vw;
    border-radius: 1vw;
    box-shadow: 0 0.1vw 0.3vw 0 hsla(140, 100%, 0%, 0.2), 0 0.1vw 0.5vw 0 hsla(140, 100%, 0%, 0.2);
  }
  .VODimage{
    height: 4vw;
    min-height: 4vw;
    width: 8vw;
    min-width: 8vw;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .active{
    background-color: var(--goalBackgroundColor3);
  }
  .inactiveInverse{
    filter: brightness(0%) invert(100%);
  }
  .inactive{
    background-color: #00000088;
    box-shadow: 0 0.1vw 0.3vw 0 hsla(140, 100%, 0%, 1), 0 0.1vw 0.5vw 0 hsla(140, 100%, 0%, 1);
    opacity:0.2;
    filter: grayscale(100%);
  }

  @media screen and (max-device-width: 767px) {
    .VODbutton{
      padding: 3vw;
      margin: 3vw;
      height: 15vw;
      min-height: 15vw;
      width: 30vw;
      min-width: 30vw;
      border-radius: 3vw;
      box-shadow: 0 0.3vw 0.9vw 0 hsla(140, 100%, 0%, 0.2), 0 0.3vw 1.5vw 0 hsla(140, 100%, 0%, 0.2);
    }
    .VODimage {
      height: 15vw;
      min-height: 15vw;
      width: 30vw;
      min-width: 30vw;
    }
    .active{
      background-color: var(--lightColor);
    }
  }
</style>